// extracted by mini-css-extract-plugin
export var actions = "_26-0";
export var actionsContainer = "_26-7";
export var border = "_26-1";
export var childFullHeight = "_26-f";
export var collapse = "_26-2";
export var content = "_26-a";
export var contentChild = "_26-e";
export var fullscreen = "_26-c";
export var hasLeftRadius = "_26-k";
export var headerContainer = "_26-3";
export var headerRow = "_26-5";
export var hidePadding = "_26-b";
export var navCollapsedGap = "_26-l";
export var noScrollX = "_26-m";
export var noScrollY = "_26-n";
export var noTopPadding = "_26-i";
export var optOutTopPadding = "_26-d";
export var pageMain = "_26-j";
export var pageOuter = "_26-g";
export var pagePadding = "_26-8";
export var pageScroll = "_26-9";
export var profile = "_26-o";
export var profileContainer = "_26-p";
export var profileImage = "_26-q";
export var profileMain = "_26-r";
export var profileSubtitle = "_26-t";
export var profileTitle = "_26-s";
export var showLeftPadding = "_26-h";
export var tabsPortalSlot = "_26-6";
export var tabsWrapper = "_26-4";
export var title = "_26-u";